import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import { ButtonPrimary } from 'core/ui/Button';
import { formatDateApi } from 'core/utils/formatters';

export default function ItemTableCoach({
  coach,
  workout,
  coaching,
  buttonColor,
  addCoach,
  setAction,
}) {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>{coach.user.name}</TableCell>
      <TableCell>
        <div className="tw-flex tw-items-center">
          <Tooltip title={t('tooltip.usersCalendar.feature')}>
            <div
              className={`tw-flex tw-w-20 tw-items-center tw-justify-center tw-rounded-md tw-p-1 tw-text-white ${coach.calendarAvailibility ? 'tw-bg-green-400 ' : 'tw-bg-red-400 '}`}
            >
              {t(coach.calendarAvailibility ? 'label.available' : 'label.unavailable')}
            </div>
          </Tooltip>
        </div>
      </TableCell>
      <TableCell>
        <div className="tw-flex tw-items-center">
          {coaching && (
            <Tooltip title={t('tooltip.workout.coaching')}>
              <div className="tw-flex tw-w-20 tw-items-center tw-justify-center tw-rounded-md tw-bg-blue-400 tw-p-1 tw-text-white">
                {t('workout.coaching')}
              </div>
            </Tooltip>
          )}
        </div>
      </TableCell>
      <TableCell align="right">
        {!coaching && (
          <div className="tw-flex tw-flex-row tw-items-center tw-justify-end tw-gap-2">
            <ButtonPrimary buttonColor={buttonColor} onClick={() => addCoach(coach.user.id)}>
              {t('button.addToThisClass')}
            </ButtonPrimary>
            {workout?.recurringId && (
              <ButtonPrimary
                buttonColor={buttonColor}
                onClick={() =>
                  setAction({
                    view: 'recurring',
                    coach: coach.user,
                    applyToAll: true,
                    every: 1,
                    endDateApplyCoach: formatDateApi(workout?.recurringEndDate),
                  })
                }
              >
                {t('button.addToRecurring')}
              </ButtonPrimary>
            )}
          </div>
        )}
      </TableCell>
    </TableRow>
  );
}

ItemTableCoach.propTypes = {};

ItemTableCoach.defaultProps = {};
